<template>
  <div class="wrapper">
    <!-- <span id="loading"><img class="tbm-loader" :src="require('../assets/img/tbm_loader.gif')"></span> -->
    <div class="animated fadeIn">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row>
        <b-col sm="6">
          <b-card>
            <div slot="header">
              <strong>Sales Profile </strong>
            </div>

            <b-row> <!-- Sales ID -->
              <b-col sm="12">
                <b-form-group>
                  <label for="sales_id">Sales ID</label>
                  <b-form-input v-model="form.sales_id" :state="salesIDState" type="text" id="sales_id" trim disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row> <!-- First Name -->
              <b-col sm="12">
                <b-form-group>
                  <label for="first_name">First Name</label>
                  <b-form-input v-model="form.first_name" :state="firstNameState" v-on:keyup="firstNameKeyUp" type="text" id="first_name" aria-describedby="input-live-help-firstname input-live-feedback-firstname" placeholder="Enter sales first name" trim></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback-firstname">
                    {{ invalid.firstName }}
                  </b-form-invalid-feedback>

                  <!-- This is a form text block (formerly known as help block) -->
                  <b-form-text id="input-live-help-firstname">Sales first name.</b-form-text>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row> <!-- Last Name -->
              <b-col sm="12">
                <b-form-group>
                  <label for="last_name">Last Name</label>
                  <b-form-input v-model="form.last_name" :state="lastNameState" v-on:keyup="lastNameKeyUp" type="text" id="last_name" aria-describedby="input-live-help-lastname input-live-feedback-lastname" placeholder="Enter sales last name"></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback-lastname">
                    {{ invalid.lastName }}
                  </b-form-invalid-feedback>
                  <b-form-text id="input-live-help-lastname">Sales last name.</b-form-text>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row> <!-- Salutation -->
              <b-col sm="12">
                <b-form-group
                  label="Salutation"
                  label-for="salutation"
                  :label-cols="12"
                  >
                  <b-form-radio-group :state="salutationState"
                    id="salutation"
                    name="salutation">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" v-model="form.salutation" id="customRadioInline1" name="salutation" class="custom-control-input" value="mr">
                      <label class="custom-control-label" for="customRadioInline1">Mr.</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" v-model="form.salutation" id="customRadioInline2" name="salutation" class="custom-control-input" value="mrs">
                      <label class="custom-control-label" for="customRadioInline2">Mrs.</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" v-model="form.salutation" id="customRadioInline3" name="salutation" class="custom-control-input" value="ms">
                      <label class="custom-control-label" for="customRadioInline3">Ms.</label>
                    </div>
                    <b-form-invalid-feedback :state="salutationState">Please select one</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="salutationState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <!-- salutation value: {{salutation + " " + first_name + " " + last_name }} -->
            </b-row>

            <b-row> <!-- Gender -->
              <b-col sm="12">
                <b-form-group
                  label="Gender"
                  label-for="gender"
                  :label-cols="12"
                  >
                  <b-form-radio-group :state="genderState"
                    id="gender"
                    name="gender">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" v-model="form.gender" id="gender1" name="gender" class="custom-control-input" value=1>
                      <label class="custom-control-label" for="gender1">Male</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" v-model="form.gender" id="gender2" name="gender" class="custom-control-input" value=2>
                      <label class="custom-control-label" for="gender2">Female</label>
                    </div>
                    <!-- {{ form.gender }} -->
                    <b-form-invalid-feedback :state="genderState">Please select one</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="genderState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <!-- gender value: {{ gender }} -->
            </b-row>

            <b-row> <!-- Email -->
              <b-col sm="12">
                <b-form-group>
                  <label for="email">Email</label>
                  <b-form-input v-model="form.email" :state="emailValid" v-on:keyup="emailKeyUp" v-on:change="emailChange" type="email" id="email" aria-describedby="input-live-help-email input-live-feedback-email" placeholder="Enter sales email address" trim></b-form-input>
                  <!-- This will only be shown if the preceding input has an invalid state -->
                  <b-form-invalid-feedback id="input-live-feedback-email">
                    {{ invalidEmail }}
                  </b-form-invalid-feedback>

                  <!-- This is a form text block (formerly known as help block) -->
                  <b-form-text id="input-live-help-email">Sales email address.</b-form-text>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row> <!-- Phone -->
              <b-col sm="12">
                <b-form-group>
                  <label for="phone">Phone</label>
                  <b-form-input v-model="form.phone" :state="phoneState" v-on:keydown="phoneKeyDown" v-on:keyup="phoneKeyUp" type="tel" id="phone" maxlength="13" aria-describedby="input-live-help-phone input-live-feedback-phone" placeholder="Enter sales phone number" trim></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback-phone">
                    {{ invalid.phone }}
                  </b-form-invalid-feedback>

                  <b-form-text id="input-live-help-phone">Sales phone number.</b-form-text>
                </b-form-group>
              </b-col>
            </b-row>
            <br><br><br><br>
          </b-card>

        </b-col>
        <b-col sm="6">
          <b-card>
            <div slot="header">
              <strong>Location </strong>
            </div>
            <!-- <b-form-group>
              <label for="address">Address</label>
              <b-form-textarea v-model="form.address" :state="addressState" type="text" id="address" placeholder="Enter your address" aria-describedby="input-live-help-address input-live-feedback-address" trim ></b-form-textarea>
              <b-form-invalid-feedback id="input-live-feedback-email">
                Enter a valid address
              </b-form-invalid-feedback>
              <b-form-text id="input-live-help-email">Your address.</b-form-text>
            </b-form-group> -->
            <b-form-group>
              <label for="province" class="typo__label">Province</label>
              <multiselect id="province" @input="getCities" @remove="removeProvince" :state="provinceState" v-model="provinceValue" :options="provinceOptions" :custom-label="nameWithLang" placeholder="-- Select Province" label="id" track-by="id" :disabled="isProvinceDisable"></multiselect>
              <b-form-invalid-feedback :state="provinceState">Please select one</b-form-invalid-feedback>
              <b-form-valid-feedback :state="provinceState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
              <!-- {{ provinceValue }} -->
            </b-form-group>
            <b-form-group>
              <label for="city">City</label>
              <multiselect id="city" @input="getDistricts" :state="cityState" v-model="cityValue" :options="cityOptions" :custom-label="nameWithLang" placeholder="-- Select City" label="id" track-by="id" :disabled="isCityDisable"></multiselect>
              <b-form-invalid-feedback :state="cityState">Please select one</b-form-invalid-feedback>
              <b-form-valid-feedback :state="cityState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
            </b-form-group>
            <b-row>
              <b-col sm="8">
              <b-form-group>
                  <label for="district">District</label>
                  <multiselect id="district" @input="getVillages" v-model="districtValue" :options="districtOptions" :custom-label="nameWithLang" placeholder="-- Select District" label="id" track-by="id" :disabled="isDistrictDisable"></multiselect>
                  <b-form-invalid-feedback :state="districtState">Please select one</b-form-invalid-feedback>
                  <b-form-valid-feedback :state="districtState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <!-- <b-col sm="4">
              <b-form-group>
                <label for="postal-code">Postal Code</label>
                <b-form-input v-model="form.postalCode" type="number" pattern="\d*" maxlength="5" minlength=1 min="0" id="postal-code" placeholder="Postal Code"></b-form-input>
              </b-form-group>
              </b-col> -->
            </b-row>
            <b-form-group>
              <label for="village">Village</label>
              <multiselect id="village" v-model="villageValue" :options="villageOptions" :custom-label="nameWithLang" placeholder="-- Select Village" label="id" track-by="id" :disabled="isVillageDisable"></multiselect>
              <b-form-invalid-feedback :state="villageState">Please select one</b-form-invalid-feedback>
              <b-form-valid-feedback :state="villageState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
            </b-form-group>

            <b-row>
              <b-col sm="8">

              </b-col>

            </b-row>

          </b-card>

          <b-card v-if="createNew">
            <div slot="header">
              <strong>Account </strong>
            </div>
            <b-form-group>
              <label for="username">Username</label>
              <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text><i class="icon-user"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input v-model="form.username" :state="isValidUsername"  v-on:keyup="usernameKeyUp"  v-on:change="usernameChange" type="text" id="username" placeholder="Enter sales username" aria-describedby="input-live-help-username input-live-feedback-username" trim ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback-username">
                {{ invalidUsername }}
              </b-form-invalid-feedback>
              </b-input-group>
              <b-form-text id="input-live-help-username">Sales username.</b-form-text>
            </b-form-group>
            <b-form-group>
              <label for="password">Password</label>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="form.password" :state="passwordState" v-on:keyup="passwordKeyUp" type="password" id="password" placeholder="Enter sales password" aria-describedby="input-live-help-password input-live-feedback-password"  autocomplete="off" trim ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-password">
                {{ invalidPassword }}
              </b-form-invalid-feedback>
              </b-input-group>

              <!-- This is a form text block (formerly known as help block) -->
              <b-form-text id="input-live-help-password">Sales password.</b-form-text>
            </b-form-group>
          </b-card>
        </b-col>

        <b-col sm="6">
        <!-- <b-card>
          <div slot="header">
            <strong>Bank Account </strong> <small>Form</small>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group>
              <label for="payroll">Payroll</label>
              <b-form-input type="text" id="payroll" placeholder="Enter your payroll"></b-form-input>
            </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="bank_acc_no">Bank Account Number</label>
                <b-form-input type="text" id="bank_acc_no" placeholder="Enter your bank account number"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card> -->
        </b-col>
      </b-row>
      <b-row v-if="createNew">
        <b-col sm="12">
           <b-card>
            <div slot="header">
              <strong>Position </strong>
            </div>
            <b-row>

              <b-col sm="6">
                <b-form-group>
                  <label for="position">Position</label>
                  <multiselect v-model="roleValue" :options="roleOptions" :custom-label="nameWithLang" placeholder="-- Select Position" label="id" track-by="id" id="position"></multiselect>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                 <b-row>
                  <b-col sm="6">
                    <b-form-group
                      label="Status Active"
                      label-for="status"
                      :label-cols="12"
                      >
                      <c-switch v-model="form.status" class="mx-1" color="primary" checked label />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
      <b-col sm="12" class ="mb-3">
        <router-link :to="{name: 'SalesManagement'}"><b-button type="button" variant="danger" class="mr-2 mb-2">Cancel</b-button></router-link>
        <b-button type="reset" variant="danger" class="mr-2 mb-2">Reset</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-2">Submit</b-button>
      </b-col>
      </b-row>
      </b-form>
    </div>
  </div>
</template>

<style>
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import axios from 'axios'
import { apiRouter } from '../router/api-routing.js'
import Multiselect from 'vue-multiselect'
import { isLoggedIn, getIdToken, removeToken, getHeaderToken } from '../user/token.js'
import { isEmailValid, stringOnly, tagPrevention } from '../shared/input-validation.js';
import $ from 'jquery'

// const singleSelect = Vue.component('single-select', {
//   data () {
//     return {
//       selected: 'orange',
//       options
//     }
//   }
// })

// const multiSelect = Vue.component('multiple-select', {
//   data () {
//     return {
//       selected: 'apples',
//       options
//     }
//   }
// })

export default {
  name: 'SalesForm',
  components: {
    cSwitch,
    Multiselect
  },
  props: ['sales_id', 'id'],
  data() {
    return {
      isValidUsername: false,
      invalidUsername: 'Enter sales username',
      invalidPassword: 'Enter sales password',
      emailValid: false,
      invalidEmail: 'Enter sales email address',
      existingEmail: '',
      isValidFirstName: false,
      isValidLastName: false,
      isValidPhone: false,
      isValidPassword: false,
      invalid: {
        firstName: 'Enter at least 1 letter',
        lastName: 'Enter at least 1 letter',
        phone: 'Enter sales phone number'
      },
      form: {
        sales_id: '',
        first_name: '',
        last_name: '',
        salutation: '',
        gender: '',
        email: '',
        phone: '',
        status: '',
        address: '',
        username: '',
        password: '',
      },
      createNew: '',
      roleValue: '',
      roleOptions: [
          { id: 2, name: 'Area Manager' },
          { id: 3, name: 'Agro' },
          { id: 4, name: 'Field Assistant' }
        ],
      provValue: '',
      provinceValue: '',
      provinceOptions: [],
      cityValue: '',
      cityOptions: [],
      districtValue: '',
      districtOptions: [],
      villageValue: '',
      villageOptions: [],
      isProvinceDisable: true,
      isCityDisable: true,
      isDistrictDisable: true,
      isVillageDisable: true,
      salesData: [],
      show: true,
      ID: '',
      password: ''
    }
  },
  computed: {
    firstNameState(){
      this.isValidFirstName = this.form.first_name.length > 0 ? true : false
      return this.isValidFirstName
      // isNameValid(this.form.first_name)
    },
    lastNameState(){
      this.isValidLastName = this.form.last_name.length > 0 ? true : false
      return this.isValidLastName
    },
    salutationState(){
      // if (this.salutation == 'mr'){
      //   document.getElementById('gender1').click()
      // } else {
      //   document.getElementById('gender2').click()
      // }
      return Boolean(this.form.salutation)
    },
    genderState(){
      return Boolean(this.form.gender)
    },
    emailState() {

    },
    phoneState(){
      const phoneRegex = /^[0-9]{10,13}$/
      this.isValidPhone = phoneRegex.test(this.form.phone)
      return this.isValidPhone
    },
    addressState(){
      return this.form.address.length > 7 ? true : false
    },
    provinceState(){
      return Boolean(this.provinceValue)
    },
    cityState(){
      return Boolean(this.cityValue)
    },
    districtState(){
      return Boolean(this.districtValue)
    },
    villageState(){
      return Boolean(this.villageValue)
    },
    salesIDState(){},
    passwordState(){
      this.isValidPassword = this.form.password.length > 5 ? true : false
      return this.isValidPassword
    },
  },
  created() {
    this.checkSession()
    /// LOADING show
    // this.showLoading()
    this.isUsernameValid = false
    // this.emailValid = false
    // this.invalidEmail = 'Email format is invalid'

  //  console.log('sales_id', this.sales_id)
    if (this.sales_id === undefined || this.sales_id === ''){ //generate sales id or not
      this.createNew = true;
      this.generateSalesID();
    } else {
      this.createNew = false;
      this.getDataBySalesID();
      // console.log('salesss', this.sales_id);
    }
    this.getProvinces()

    /// LOADING close/hide
    // this.$swal.close()
  },
  mounted(){
  },
  watch: {
    existingEmail(newVal, oldVal){
      // console.log('existing.email', newVal + oldVal)
      if(newVal){
        //CHECK INPUT EMAIL
        if (this.form.email == ''){
          this.emailValid = false
          this.invalidEmail = 'Enter sales email address'

        } else if (this.existingEmail!='' && this.existingEmail==this.form.email){
          this.emailValid = true
          // console.log('SKIP')
        }
        //this.$router.push({name: 'SalesManagement'});
      } else {}
    }
  },
  methods: {
    checkSession(){
      if(isLoggedIn() === 1){
      } else {
        this.$router.push({name: 'Login'});
      }
    },
    firstNameKeyUp: function(evt){
      this.form.first_name = tagPrevention(evt, this.form.first_name, 1)
    },
    lastNameKeyUp: function(evt){
      this.form.last_name = tagPrevention(evt, this.form.last_name, 1)
    },
    usernameKeyUp: function(evt){
      this.form.username = tagPrevention(evt, this.form.username, 1)
    },
    usernameChange: function(evt){

      this.$emit("change", evt)
      // console.log("change", evt)

      // if(!evt){
      //   this.isValidUsername = false
      //   return false
      // }

      // console.log('username', this.form.username)
      if (this.form.username == ''){
        this.isValidUsername = false
        this.invalidUsername = 'Enter sales username'

      } else if (this.form.username.length > 2){
        const usernameRegex = /^[A-Za-z]+$/
         if (usernameRegex.test(evt)){
           this.checkAvailable(2, evt)
         } else {
           this.isValidUsername = false
           this.invalidUsername = 'Username format is invalid, use letter [a-z] or [A-Z].'
         }
      } else {
        this.isValidUsername = false
        this.invalidUsername = 'Username at least 3 character'
      }

    },
    phoneKeyDown: function(evt){
      evt = (evt) ? evt : window.event
      // console.log('_',evt)
      //var charCode = (evt.ke) ? evt.which : evt.keyCode
      if(evt.ctrlKey){
        if ([65,67].indexOf(evt.keyCode) +1){
        } else {
          evt.preventDefault()
        }
      } else if(evt.shiftKey){
        if (evt.keyCode == 35 || evt.keyCode == 36 || (evt.keyCode > 36 && evt.keyCode < 41)){
        } else {
          evt.preventDefault()
        }
      } else if ((evt.keyCode > 36 && evt.keyCode < 41) || (evt.keyCode > 47 && evt.keyCode < 58) || [8,9,35,36,46].indexOf(evt.keyCode) +1){
      } else {
        evt.preventDefault()
      }
    },
    phoneKeyUp: function(evt){
      evt = (evt) ? evt : window.event
      this.form.phone = tagPrevention(evt, this.form.phone, 1)
      if(!evt){
        this.isValidPhone = false
        return false
      }
      let input = evt.target.value

      if (this.form.phone == ''){
        this.isValidPhone = false
        this.invalid.phone = 'Enter sales phone number'

      } else if (this.form.phone.length < 10) {
        this.isValidPhone = false
        this.invalid.phone = 'Enter at least 10 digit'

      } else {
        const phoneRegex = /^[0-9]{10,13}$/
        this.isValidPhone = phoneRegex.test(input)
      }

    },
    passwordKeyUp: function(evt){
      this.form.password = tagPrevention(evt, this.form.password, 0)
      if (this.form.password == ''){
        this.invalidPassword = 'Enter sales password'

      } else if (this.form.password.length < 6){
        this.invalidPassword = 'Enter at least 6 character'

      } else {

      }
    },
    emailKeyUp: function(evt){
      this.form.email = tagPrevention(evt, this.form.email, 2)
      this.emailChange()
    },
    emailChange: function(evt){
      this.$emit("change", evt)
      // console.log("change", evt)
      // console.log('existing email',this.existingEmail)
      // console.log('input email',this.form.email)

      if (this.form.email == ''){
        this.emailValid = false
        this.invalidEmail = 'Enter sales email address'

      } else if (this.existingEmail!='' && this.existingEmail==this.form.email){
        this.emailValid = true
        // console.log('SKIP')

      } else {
        // console.log('checkingg....')
        const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
        if (emailRegex.test(this.form.email)){
          this.checkAvailable(1, evt)
        } else {
          this.emailValid = false
          this.invalidEmail = 'Email format is invalid'
        }
      }

      // console.log('thisss', this.form.email)

      // if (this.form.email == '' || this.existingEmail == '') {
      //   this.emailValid = false
      // }
    },
    checkEmail(){
      if (this.form.email == ''){
        this.emailValid = false
        this.invalidEmail = 'Enter sales email address'

      } else if(this.existingEmail == this.form.email){
        this.emailValid = true

      } else {
        this.emailValid = false
        this.invalidEmail = 'Enter sales email address'
      }
    },
    checkAvailable(type, input){

      let api
      let fd
      if (type == 1){
        api = apiRouter().check_email_sales
        fd = {'email': input}
      } else {
        api = apiRouter().check_username_sales
        fd = {'user_name': input}
      }

        axios.post(api, fd, getHeaderToken())
        .then(response => {
           // console.log('checkusernamesales',response);
          if(response.status === 200){
            if(response.data.code == 200){
              // console.log('data200')

              if (type==1) { //EMAIL
                this.emailValid = true
              } else {
                this.isValidUsername = true
              }

            } else {
              // console.log('dataNOT 200')
              if (type==1) { //EMAIL
                this.emailValid = false
                this.invalidEmail = 'Email already used'
              } else {
                this.isValidUsername = false
                this.invalidUsername = 'Username already used'
              }
            }
          } else {
            if (type==1) { //EMAIL
                this.emailValid = false
                this.invalidEmail = 'Email already used'
              } else {
                this.isValidUsername = false
                this.invalidUsername = 'Username already used'
              }
          }
        })
        .catch(function (error) {
            this.isValidUsername = false
            this.emailValid = false
        });

    },
    nameWithLang ({ name, language }) {
      return `${name}`
    },
    modalOKv2(message, buttonVariant, page){
      this.$bvModal.msgBoxOk(message, {
        title: 'Report',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: buttonVariant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      }).then(value => {
        if (page == ''){
        } else {
          this.$router.replace({name: page});
        }
      })
      .catch(err => {
        console.log(err)
        // An error occurred
      })
    },
    modalError(errorMessage){
      this.modalOK(errorMessage, 'error','');
    },
    modalOK(message, buttonVariant, page){
       this.$swal({title: message, html:'',text: '',
          type: buttonVariant,
          showCancelButton: false,
          confirmButtonText: 'OK',
          confirmButtonColor: '#4DBD74',
          showCloseButton: false,
          showLoaderOnConfirm: true,
      }).then((result) => {
        if (page == ''){
        } else {
          this.$router.replace({name: page});
        }
      });
    },
    showLoading(){
       this.$swal({
        imageUrl: require('../assets/img/tbm_loader.gif'),
        imageWidth: 200,
        imageHeight: 200,
        imageAlt: 'Custom image',
        showConfirmButton: false
      }).then((result) => {
        // if (page == ''){
        // } else {
        //   this.$router.replace({name: page});
        // }
      });
    },
    getCities(){
      this.removeCity();
      let $vm = this;
    // console.log('UPDATE CITY 2 ' + this.provinceValue.id);
    axios.get(apiRouter().cities + this.provinceValue.id, getHeaderToken())
    .then(function (response){
      // console.log(response);
      if(response.status === 200){
          $vm.cityOptions = response.data.data;
          $vm.isCityDisable = false;
          // console.log("CITY " + $vm.cityOptions);

      } else {
        // console.log("not 200");
      }
    })
    .catch(function (error) {
        // console.log(error);
    });
    },

    getDistricts(){
      this.removeDistrict();
      let $vm = this;

    // console.log('UPDATE DISTRICT  ' + this.cityValue.id);
    axios.get(apiRouter().districts + this.cityValue.id, getHeaderToken())
    .then(function (response){
      // console.log(response);
      if(response.status === 200){
          $vm.districtOptions = response.data.data;
          $vm.isDistrictDisable = false;
          // console.log("CITY " + $vm.districtOptions);

      } else {
        // console.log("not 200");
      }
    })
    .catch(function (error) {
        // console.log(error);
    });
    },

    getVillages(){
      this.removeVillage();
      let $vm = this;

    // console.log('UPDATE VILLAGE ' + this.districtValue.id);
    axios.get(apiRouter().villages + this.districtValue.id, getHeaderToken())
    .then(function (response){
      // console.log(response);
      if(response.status === 200){
          $vm.villageOptions = response.data.data;
          $vm.isVillageDisable = false;
          // console.log("CITY " + $vm.villageOptions)

      } else {
        // console.log("not 200");
      }
    })
    .catch(function (error) {
        // console.log(error);
    });
    },

    removeProvince(){
      this.removeCity()
    },

    removeCity(){
      this.isCityDisable = true;
      this.cityValue = '';
      this.cityOptions = [];
      this.removeDistrict();
    },

    removeDistrict(){
      this.isDistrictDisable = true;
      this.districtValue = '';
      this.districtOptions = [];
      this.removeVillage();
    },

    removeVillage(){
      this.isVillageDisable = true;
      this.villageValue = '';
      this.villageOptions = [];
    },

    onSubmit(evt) {
        evt.preventDefault()
        //alert(JSON.stringify(this.form));
        //+ 'province: ' + provinceValue + 'city: ' + cityValue + 'district: ' + districtValue + 'village: ' + villageValue

      const fill = "Please fill ";
      const choose = "Please choose ";
      if (this.form.first_name == '' || !this.isValidFirstName) {$("#first_name").focus(); return this.modalError(fill + 'First Name');}
      if (this.form.last_name == '' || !this.isValidLastName) {$("#last_name").focus(); return this.modalError(fill + 'Last Name');}
      if (this.form.salutation == '') {$("#salutation").focus(); return this.modalError(choose + 'Salutation');}
      if (this.form.gender == '') {$("#gender").focus(); return this.modalError(choose + 'Gender');}
      if (this.form.email == '' || !this.emailValid) {$("#email").focus(); return this.modalError(fill + 'Email');}
      if (this.form.phone == '' || !this.isValidPhone) {$("#phone").focus(); return this.modalError(fill + 'Phone');}
      // if (this.form.address == '') return alert(fill + 'address');
      if (this.createNew){
        if (this.roleValue == '') {$("#position").focus(); return this.modalError(choose + 'Position');}
      }
      if (this.provinceValue == '' || this.provinceValue == null) {$("#province").focus(); return this.modalError(choose + 'Province');}
      if (this.cityValue == '' || this.cityValue == null) {$("#city").focus(); return this.modalError(choose + 'City');}
      if (this.districtValue == '' || this.districtValue == null) {$("#district").focus(); return this.modalError(choose + 'District');}
      if (this.villageValue == '' || this.villageValue == null) {$("#village").focus(); return this.modalError(choose + 'Village');}
      if (this.createNew){
        if (this.form.username == '' || !this.isValidUsername) {$("#username").focus(); return this.modalError(fill + 'Username');}
        if (this.form.password == '' || !this.isValidPassword) {$("#password").focus(); return this.modalError(fill + 'Password');}
      }

      this.submitDataSales();
    },
    onReset(evt) {
      evt.preventDefault()

      this.form.sales_id = this.form.sales_id;
      // Reset our form values

      this.form.first_name = ''
      this.form.last_name = ''
      this.form.salutation = ''
      this.form.gender = ''
      this.form.email = ''
      this.emailValid = false
      this.invalidEmail = 'Enter sales email address'
      this.form.phone = ''
      this.form.role_id = ''
      this.form.status = ''
      // this.form.address = ''
      this.form.username = ''
      this.form.password = ''
      this.provinceValue = ''
      this.cityValue = ''
      this.districtValue = ''
      this.villageValue = ''

      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      });
    },
    getProvinces(){

      this.removeProvince();
      let $vm = this;

      axios.get(apiRouter().provinces, getHeaderToken())
      .then(function (response){
        //console.log(response);
        if(response.status === 200){
            //console.log("Get Provinces success");
            $vm.provinceOptions = response.data.data;
            $vm.isProvinceDisable = false;
            //console.log("PROVINCE " + $vm.provinceOptions);

        } else {
          //console.log("not 200");
        }
      })
      .catch(function (error) {
        // this.$router.replace({name: 'SalesManagement'});
          //console.log(error);
      });
    },
    generateSalesID(){
      let $vm = this
      axios.get(apiRouter().generate_sales_id, getHeaderToken())
      .then((response) => {

        if(response.status === 200){
            // console.log("Get Generate Sales ID success ", response.data);
            $vm.form.sales_id = response.data;
            // console.log("SALES_ID " + $vm.form.sales_id);
            // $('#loading').hide
            this.checkEmail()

        } else {
          // console.log("not 200");
        }
      })
      .catch(function (error) {
        // this.$router.replace({name: 'SalesManagement'});
      });
      // document.getElementById('loading').style.display="none";
      //$('#loading').hide;
      //this.$swal.clickCancel();
    },
    getDataBySalesID(){
      // this.showLoading()
      let $vm = this;

      axios.get(apiRouter().view_data_sales + this.id, getHeaderToken())
      .then(function (response){
        // console.log(response);

        if(response.status === 200){

            // console.log(response.data);
            $vm.form.sales_id = response.data.sales_id;
            $vm.ID = response.data.id;

            $vm.form.first_name = response.data.first_name;
            $vm.form.last_name = response.data.last_name;
            $vm.form.salutation = response.data.salutation;
            $vm.form.gender = response.data.gender;
            $vm.form.email = response.data.email;
            $vm.existingEmail = response.data.email;
            $vm.form.phone = response.data.phone;

            //console.log("PRINTTT " + $vm.roleOptions["2"])

            let roleName;
            if (response.data.role_id == 2){
              roleName = 'Area Manager';
            } else if (response.data.role_id == 3){
              roleName = 'Agro';
            } else if (response.data.role_id == 4){
              roleName = 'Field Assistant';
            }
            $vm.roleValue = { id: response.data.role_id, name: roleName };

            let isActive = response.data.status==1? true : false;
            $vm.form.status = isActive;

            // $vm.form.address = response.data.address;
            $vm.provinceValue = { id: response.data.province_id, name: response.data.province_name };
            $vm.cityValue = { id: response.data.city_id, name: response.data.city_name };
            $vm.districtValue = { id: response.data.district_id, name: response.data.district_name };
            $vm.villageValue = { id: response.data.village_id, name: response.data.village_name };

            $vm.form.username = response.data.user_name;
            $vm.form.password = response.data.password;

            this.checkEmail()

            //console.log("success get SALES ID: " + $vm.form.sales_id);

        } else {
          // console.log("not 200");
        }
      })
      .catch(function (error) {
        // if (error){
        //   this.$router.push({name: 'SalesManagement'})
        // }
          // console.log(error);
          //document.getElementById('testLoading').click();
      });


      // $('#loading').style.display="none"
      //document.getElementById('loading').style.display="none";
    },
    submitDataSales(){
      const formData = new FormData();

      formData.append('first_name', stringOnly(this.form.first_name));
      formData.append('last_name', stringOnly(this.form.last_name));
      formData.append('profile_picture', "profile_picture.jpg");
      formData.append('phone', stringOnly(this.form.phone));
      formData.append('email', stringOnly(this.form.email));
      formData.append('gender', '' + this.form.gender);
      formData.append('salutation', this.form.salutation.toString());
      formData.append('role_id', this.roleValue.id.toString());
      formData.append('province_id', this.provinceValue.id.toString());
      formData.append('city_id', this.cityValue.id.toString());
      formData.append('district_id', this.districtValue.id.toString());
      formData.append('village_id', this.villageValue.id.toString());
      formData.append('status', this.form.status===true? "1" : "2");
      if (this.createNew){
        formData.append('user_name', stringOnly(this.form.username));
        formData.append('password', stringOnly(this.form.password));
        formData.append('sales_id', this.form.sales_id);
        formData.append('parent_id',"0".toString());

        // console.log('sales_id', this.form.sales_id);
        // console.log('parent_id', 0);
        // console.log('user_name', this.form.username);
        // console.log('password', this.form.password);
      }


      // console.log('first_name', this.form.first_name);
      // console.log('last_name', this.form.last_name);
      // console.log('profile_picture', 'profile_picture.jpg');
      // console.log('phone', this.form.phone);
      // console.log('email', this.form.email);
      // console.log('gender', this.form.gender);
      // console.log('salutation', this.form.salutation);
      // console.log('role_id', this.roleValue.id);
      // console.log('province_id', this.provinceValue.id);
      // console.log('city_id', this.cityValue.id);
      // console.log('district_id', this.districtValue.id);
      // console.log('village_id', this.villageValue.id);
      // console.log('status', this.form.status===true? "1" : "2");

      if (this.createNew){ //CREATE NEW
          axios.post(apiRouter().create_sales, formData, getHeaderToken())
          .then(response => {
              // console.log(this);
              //document.getElementById('testLoading').click();
            if(response.status === 200){
              // console.log(response.data);
              if(response.data.status == "200"){
                this.modalOK(this.form.first_name + " "+ this.form.last_name + ' added successfully', 'success', 'SalesManagement');

              } else {
                this.modalOK(this.form.first_name + " "+ this.form.last_name + ' add failed', 'error', '');
              }
            } else {
              this.modalOK(this.form.first_name + " "+ this.form.last_name + ' add failed', 'error', '');
            }
        })
        .catch(function (error) {
            //console.log(error);
            // this.modalOK(this.form.first_name + " "+ this.form.last_name + ' save failed', 'error', '');
        });
      } else { //UPDATE EXISTING

        axios.post(apiRouter().update_sales + this.id, formData, getHeaderToken())
          .then(response => {
            // console.log('dataaa', response.data.status);
            // console.log('status', response.status);
            if(response.status == 200){
              // console.log('berhasilll', response.data);
              if (response.data.status == '200'){
                this.modalOK(this.form.first_name +' '+ this.form.last_name + ' edit successfully', 'success', 'SalesManagement')
                // console.log('Halo');
              } else {
                this.modalOK(this.form.first_name +' '+ this.form.last_name + ' edit failed', 'error', '');
                // console.log('Halo else ');
              }
            } else {
              this.modalOK(this.form.first_name +' '+ this.form.last_name + ' edit failed', 'error', '');
              // console.log('Halo eeeee');

            }
        })
        .catch(function (error) {
            // console.log(error);
        });

      }

    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
